import React from 'react';
import PropTypes from 'prop-types';
import BarChartWithThreshold from './BarChartWithThreshold';
import { chartTheme } from './chartTheme';

const BarChartPerformance = ({ data = { sections: [] } }) => {
  const numericPercentage = data.numericPercentage;

  return (
    <BarChartWithThreshold
      data={data}
      title="Student Performance Breakdown by Section"
      series={[
        {
          dataKey: 'percentBelowThreshold',
          name: `Students Below ${numericPercentage}%`,
          color: chartTheme.secondary,
          stackId: 'a',
        },
        {
          dataKey: 'percentAboveThreshold',
          name: `Students Above ${numericPercentage}%`,
          color: chartTheme.main,
          stackId: 'a',
        },
      ]}
    />
  );
};

export default BarChartPerformance;

BarChartPerformance.propTypes = {
  data: PropTypes.shape({
    sections: PropTypes.array,
    numericPercentage: PropTypes.number,
  }).isRequired,
};
